<template>
    <div class="plays">
        <div class="main">
            <video ref="MainVideoRef" width="100%" height="100%" controls v-if="mainVideoComputed"
                :key="`main-${mainVideoComputed}-${videoIndex}`" @play="onMainPlay" @pause="onMainPause"
                @timeupdate="onMainTimeUpdate" @volumechange="onMainVolumechange" @ratechange="onMainRatechange">
                <source :src="mainVideoComputed" type="video/mp4" />
                <source :src="mainVideoComputed" type="video/ogg" />
                <span>您的浏览器不支持 HTML5 video 标签。</span>
            </video>
        </div>
        <div class="thumb" :class="{ hide: !thumbShow }" v-if="thumbVideoComputed">
            <div class="operate" @click="thumbShow = !thumbShow">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" v-if="thumbShow">
                    <path fill="currentColor"
                        d="M452.864 149.312a29.12 29.12 0 0 1 41.728.064L826.24 489.664a32 32 0 0 1 0 44.672L494.592 874.624a29.12 29.12 0 0 1-41.728 0 30.592 30.592 0 0 1 0-42.752L764.736 512 452.864 192a30.592 30.592 0 0 1 0-42.688m-256 0a29.12 29.12 0 0 1 41.728.064L570.24 489.664a32 32 0 0 1 0 44.672L238.592 874.624a29.12 29.12 0 0 1-41.728 0 30.592 30.592 0 0 1 0-42.752L508.736 512 196.864 192a30.592 30.592 0 0 1 0-42.688z">
                    </path>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" v-else>
                    <path fill="currentColor"
                        d="M529.408 149.376a29.12 29.12 0 0 1 41.728 0 30.592 30.592 0 0 1 0 42.688L259.264 511.936l311.872 319.936a30.592 30.592 0 0 1-.512 43.264 29.12 29.12 0 0 1-41.216-.512L197.76 534.272a32 32 0 0 1 0-44.672l331.648-340.224zm256 0a29.12 29.12 0 0 1 41.728 0 30.592 30.592 0 0 1 0 42.688L515.264 511.936l311.872 319.936a30.592 30.592 0 0 1-.512 43.264 29.12 29.12 0 0 1-41.216-.512L453.76 534.272a32 32 0 0 1 0-44.672l331.648-340.224z">
                    </path>
                </svg>
            </div>
            <div class="video">
                <video ref="ThumbVideoRef" width="100%" height="100%" :key="`thumb-${mainVideoComputed}-${videoIndex}`">
                    <source :src="thumbVideoComputed" type="video/mp4" />
                    <source :src="thumbVideoComputed" type="video/ogg" />
                    <span>您的浏览器不支持 HTML5 video 标签。</span>
                </video>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        videos: {
            type: Array,
            default: () => []
        },
        videoIndex: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            thumbShow: true
        }
    },
    computed: {
        mainVideoComputed() {
            return this.videos[0] || ''
        },
        thumbVideoComputed() {
            return this.videos[1] || ''
        }
    },
    mounted() {

    },
    methods: {
        onMainPlay() {
            this.$refs.ThumbVideoRef && this.$refs.ThumbVideoRef.play()
        },
        onMainPause() {
            this.$refs.ThumbVideoRef && this.$refs.ThumbVideoRef.pause()
        },
        onMainTimeUpdate() {
            if (this.$refs.ThumbVideoRef) {
                const time = (this.$refs.MainVideoRef && this.$refs.MainVideoRef.currentTime) || 0
                if (this.$refs.ThumbVideoRef.currentTime !== time) {
                    this.$refs.ThumbVideoRef.currentTime = time
                }
            }
        },
        onMainVolumechange(event) {
            if (this.$refs.ThumbVideoRef) {
                this.$refs.ThumbVideoRef.muted = event.target.muted
                this.$refs.ThumbVideoRef.volume = event.target.volume
            }
        },
        onMainRatechange(event) {
            if (this.$refs.ThumbVideoRef) {
                this.$refs.ThumbVideoRef.playbackRate = event.target.playbackRate
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/base";

.plays {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .main {
        width: 100%;
        height: 100%;
        background: #141414;
    }

    .thumb {
        position: absolute;
        right: 0;
        top: 0px;
        @include flex(flex-start, flex-end);
        transition: 0.3s;
        filter: drop-shadow(0 0 10px rgba(#fff, 0.1));

        &.hide {
            margin-right: -140px;
        }

        .operate {
            @include flex(center, center);
            width: 25px;
            height: 36px;
            background: #000;
            border-radius: 4px 0 0 4px;
            color: rgba(#fff, 0.8);
            cursor: pointer;
            svg {
                width: 20px;
                height: 20px;
            }
        }

        .video {
            width: 130px;
            height: 130px;
            background: #000;
            padding: 5px;
        }
    }
}
</style>